export const listInfo = (msg: string, details: any[]) => {
  const lines = (details ?? [])
    .map((detail: any) => `${detail?.fecha ?? ''} ${detail?.motivo ?? ''}`.trim())
    .filter((line) => line.length > 0);

  if (!lines.length) return msg;

  return [msg, ...lines.map((line) => `• ${line}`)].join('\n');
};
